// extracted by mini-css-extract-plugin
export default {"MainButton":"MainButton_MainButton__gdRz-","Disabled":"MainButton_Disabled__Nl8D3"};